import { initSentry, Sentry } from "@/lib/sentry";
initSentry();
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { AuthProvider } from "@/contexts/AuthContext";
import App from "./App";
import "./index.css";

// Initialize Paddle.js (loaded via CDN in index.html)
const Paddle = (window as any).Paddle;
const paddleToken = import.meta.env.VITE_PADDLE_CLIENT_TOKEN;
if (Paddle && paddleToken) {
  if (import.meta.env.VITE_PADDLE_ENVIRONMENT !== 'production') {
    Paddle.Environment.set('sandbox');
  }
  Paddle.Initialize({ token: paddleToken });
} else if (!paddleToken) {
  console.warn('[ReqTrack] VITE_PADDLE_CLIENT_TOKEN is not set — Paddle checkout will not work.');
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
